export enum EValidationKey {
  COMMON = 'COMMON',
}
